/* istanbul ignore*/
import { datadogRum } from '@datadog/browser-rum'
import configment from '@adc/configment'

import coreLogger from '@adc/logger'

const logger = coreLogger.forModule('datadog')
const environment = configment.get('ENV', 'ci')
const datadogRUMConfig = configment.get('DATADOG_BROWSER_RUM_CONFIG', {})
const datadogRUMEnabled = configment.get('ENABLE_DATADOG_BROWSER_RUM', false)
const datadogRUMSessionReplayEnabled = configment.get(
  'ENABLE_DATADOG_BROWSER_RUM_SESSION_REPLAY',
  false
)

if (
  datadogRUMEnabled &&
  datadogRUMConfig.applicationId &&
  datadogRUMConfig.clientToken
) {
  logger.info('RUM enabled.')

  datadogRum.init({
    // Configs here can be overriden by dynamic config for this
    sampleRate: 100,
    premiumSampleRate: 50,
    // This is potentially sensitive information which is why we don't enable it by default. To enable this a lot more
    // care should be taken by the sprint teams to manage sensitive data (it this is for marketing though, I'd argue we
    // don't need a lot of this anyway)
    trackInteractions: false,
    defaultPrivacyLevel: 'mask-user-input',
    site: 'datadoghq.com',
    // All clusters run with https and secure cookies set except devs running local
    // dev clusters
    useSecureSessionCookie: environment !== 'dev',

    ...datadogRUMConfig,

    // This helps link RUM traces with backend APM traces related to the request
    allowedTracingOrigins: [configment.get('RESI_GRAPH_API_URL', '')].filter(
      Boolean
    ),

    // Configs here are controlled by the calling code and will always overwrite anything in the datadog config
    service: configment.get('APP_NAME'),
    version: configment.get('VERSION_IDENTIFIER'),
    env: environment,
  })

  if (datadogRUMSessionReplayEnabled) {
    datadogRum.startSessionReplayRecording()
  }
} else {
  logger.info('RUM disabled.')
}
